import React from 'react';
import { Box, Typography } from '@mui/material';

// [Phase 3] Full referral list table will be built here.
const TransitionListView: React.FC = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" fontWeight={600} gutterBottom>
        All Referrals
      </Typography>
      <Typography color="text.secondary">
        Referral list table — coming in Phase 3.
      </Typography>
    </Box>
  );
};

export default TransitionListView;
